<div class="modal-header">
    <h4 class="modal-title">Registrar Nueva Publicidad</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    </button>
</div>
<div class="modal-body">
    <div class="contenedor">
        <div class="item-1">
            <form [formGroup]="form">
                <div class="row">
                    <div class="col-12 col-sm-6">
                        <label for="titulo">Título</label>
                        <input type="text" class="form-control" id="titulo" formControlName="titulo"
                            [ngClass]="{'is-invalid': form.controls['titulo'].errors && form.controls['titulo'].touched}">
                        <div class="invalid-feedback">
                            Debe ingresar un valor en el campo
                        </div>
                        <div class="mb-4" *ngIf="!form.controls['titulo'].errors || !form.controls['titulo'].touched">
                        </div>
                    </div>
                    <div class="col-12 col-sm-6">
                        <label for="tipo">Tipo</label>
                        <select class="form-select" id="tipo" formControlName="tipo"
                            [ngClass]="{'is-invalid': form.controls['tipo'].errors && form.controls['tipo'].touched}">
                            <option value="1">Banner</option>
                            <option value="2">PopUp</option>
                        </select>
                        <div class="invalid-feedback">
                            Debe seleccionar un elemento
                        </div>
                        <div class="mb-4" *ngIf="!form.controls['tipo'].errors || !form.controls['tipo'].touched">
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-sm-12">
                        <label for="url">URL</label><label class="campo-opcional"> (Opcional)</label>
                        <input type="text" class="form-control" id="url" formControlName="url"
                            [ngClass]="{'is-invalid': form.controls['url'].errors && form.controls['url'].touched}">
                        <div class="invalid-feedback">
                            Debe ingresar un valor en el campo
                        </div>
                        <div class="mb-4" *ngIf="!form.controls['url'].errors || !form.controls['url'].touched">
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 col-sm-12">
                        <label for="descripcion">Descripción</label><label class="campo-opcional"> (Opcional)</label>
                        <textarea class="form-control" id="descripcion" rows="3"
                            formControlName="descripcion"></textarea>
                    </div>
                </div>
                <br>
                <div class="row">
                    <div class="col-12 col-sm-12">
                        <label> Imagen publicitaria (jpg, png, jpeg, o cualquier otro archivo de imagen)</label>
                        <input type="file" class="form-control" [formControl]="archivo" accept='image/*'
                            [ngClass]="{'is-invalid': archivo.errors && archivo.touched}"
                            (change)="onImageChange($event)">
                        <div class="invalid-feedback" *ngIf="archivo.errors?.['required']">
                            Debe ingresar un valor en el campo
                        </div>
                        <div class="mb-4" *ngIf="!form.controls['url'].errors || !form.controls['url'].touched">
                        </div>
                    </div>
                </div>

                <h6><b>Imagen</b></h6>
                <div class="row">
                    <div class="col-12 col-sm-12">
                        <div class="image-container"
                            [ngClass]="{'banner': form.controls['tipo'].value == 1, 'popup': form.controls['tipo'].value == 2}">
                            <div *ngIf="imgFile">
                                <img [src]="imgFile" class="image-preview"
                                    [ngClass]="{'image-preview-banner': form.controls['tipo'].value == 1, 'image-preview-popup': form.controls['tipo'].value == 2}">
                            </div>
                            <div *ngIf="!imgFile">
                                <div class="empty-image-preview">
                                    <i class="fa fa-file-image fa-4x icon-cog"></i><br><br>
                                    <label>Sin imagen publicitaria</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </form>
        </div>
        <div class="item-2" *ngIf="mostrarVistaPrevia">
            <label class="label-vista-previa">Vista Previa</label>
            <div class="vista-previa">
                <img *ngIf="form.controls['tipo'].value == 1" class="imagen-vista-previa"
                    src="../../../../assets/system/preview_banner.png">
                <img *ngIf="form.controls['tipo'].value == 2" class="imagen-vista-previa"
                    src="../../../../assets/system/preview_popup.png">
                <div *ngIf="imgFile">
                    <img [src]="imgFile"
                        [ngClass]="{'banner-overlay': form.controls['tipo'].value == 1, 'popup-overlay': form.controls['tipo'].value == 2}">
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button *ngIf="!mostrarVistaPrevia && imgFile" type="button" class="btn btn-primary" (click)="showPreview()">Vista
        Previa</button>
    <button type="button" class="btn btn-success" (click)="guardar()">Registrar</button>
    <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss('Cancel click')">Cancelar</button>
</div>